// extracted by mini-css-extract-plugin
module.exports = {"refComments":"decisions_references-module__refComments--1oDgW"};